import ContextMenuItem from "../ContextMenuItem";
import { FaFileExport, FaTrash } from "react-icons/fa6";
import { FaFileImport } from "react-icons/fa6";
import { Seperator } from "../../rightContent/richTextHeader/Seperator";
import { ContextMenuSeparator } from "../ContextMenu";

export default function TitleContextMenu(props: {
    exportData: () => void;
    importData: () => void;
    deleteData: () => void;
}) {
    // Render
    return (
        <div>
            <ContextMenuItem
                label="Export Data"
                icon={<FaFileExport size={14} className="ml-[2px] mr-[-2px]" />}
                callbackFunction={() => {
                    props.exportData();
                }}
            />
            <ContextMenuItem
                label="Import Data"
                icon={<FaFileImport size={14} className="ml-[-2px]" />}
                callbackFunction={() => {
                    props.importData();
                }}
            />
            <ContextMenuSeparator />
            <ContextMenuItem
                label="Delete All Data"
                icon={<FaTrash size={14} className="ml-[-2px]" />}
                hoverColor="red"
                callbackFunction={() => {
                    props.deleteData();
                }}
            />
        </div>
    );
}
